(function(){
  'use strict';
  
  
  document.addEventListener('DOMContentLoaded', function load() {
    if (!window.jQuery) return setTimeout(load, 100);
    main();
  }, false);
  
  
  function main() {
    var apiurl = "https://honorthebeard-givecode-5.wl.r.appspot.com";
    var prodToCart = [];
    var placeholder = "https://cdn.shopify.com/s/files/1/0259/1821/0095/files/Bundler_Placeholder.png?v=1642692050";
    var bundleConfig = [];
    var activeBundle = {};
    var collID = $("#CollectionSection").data("collection");
    
    
   	
    function initBundle() {
      activeBundle = bundleConfig[0];
      for(var i=0;i<bundleConfig.length;i++) {
        var bar = bundleConfig[i];
        if(i == 0) {
          $(".tabs-wrap").append(`<div class="tabbar active" data-idx="${i}"><a href="#"><span>${bar.name}</span></a></div>`);
          continue;
        }
        $(".tabs-wrap").append(`<div class="tabbar" data-idx="${i}"><a href="#"><span>${bar.name}</span></a></div>`);
      }
      setBundle(prodToCart, true);
      $(".tabbar").click(function(e){
    	e.preventDefault();
      	var idx = $(this).data('idx');
      	$(".tabbar").removeClass("active");
      	$(`.tabbar[data-idx="${idx}"]`).addClass("active");
      	activeBundle = bundleConfig[idx];
        prodToCart = [];
      	
        setBundle(prodToCart, true);
        $(".quick-product__label").html("Add");
       
      });
      $("#CollectionSection").show();
    }
    
    
    function setBundle(data, reset) {
      	if(!reset) {
          if(prodToCart.length >= activeBundle.maxItems) {
          	return;
          }
        	prodToCart.push(data);
        }
    	
      	var discount = activeBundle.discount;
      	var total = 0;
      	$.each(prodToCart, function(i, val){
      		total += val.price;
      	});
     	
      	var total_discount = total - (total * discount);
      	var saved = total - total_discount 
        $("#bundle-price").html(`Total: $${(total_discount / 100).toFixed(2)}`);
      	//$("#bundle-discount").html(`You saved $${(saved/100).toFixed(2)}`);
      	
      	$(".bundle-previews > *").remove();
      	var bundlePreviews = $(".bundle-previews");
      	for(var i=0;i<activeBundle.maxItems;i++) {
          if(prodToCart[i]) {
            var obj = prodToCart[i];
            bundlePreviews.append(`<div class="item-wrap remove" data-idx="${i}"><img data-idx="${i}" class="added" src="${obj.img}" alt="Bundle Product" /><span data-idx="${i}" class="remove-bundle-item">X</span></div>`);
          }else{
            bundlePreviews.append(`<div class="item-wrap"><img src="${placeholder}" alt="Bundle Product" /></div>`);
          }
        }
      
        $(".bundle-save").html(`(Save ${(activeBundle.discount * 100)}%)`);
        $(".bundle-total").html(`Total: $${(total_discount / 100).toFixed(2)}`);
      
      	if(prodToCart.length >= activeBundle.maxItems) {
      		$(".bundle-need").hide();
          	$(window).width() <= 600 ? $(".multicheckout").show() : $(".multicheckout-desktop").prop("disabled", false);
        }else {
            $(".bundle-need").show();
          	$(window).width() <= 600 ? $(".multicheckout").hide() : $(".multicheckout-desktop").prop("disabled", true);
            
          	
        	$(".bundle-need").html(`Your bundle needs ${(activeBundle.maxItems - prodToCart.length)} more items`);
        }
      	
              
    
    }
    
    
    $(".multiclick").click(function(e) {
    	e.preventDefault();
      	var data = {
          id: $(this).data('id'),
          price: $(this).data('price'),
          img: $(this).data('img'),
          quantity: 1
        }
        var idx = -1;
      	for(var i = 0; i < prodToCart.length; i++) {
      		if(prodToCart[i].id == data.id) {
            	idx = i;
              	break;
          }
      	}
      
      setBundle(idx >= 0 ? prodToCart[idx] : data);
    });
    
    
 
    $(".multicheckout, .multicheckout-desktop").click(function(e) {
    	e.preventDefault();
      	
      	
      	$(this).prop("disabled", true);
      
      	var data = {items: []};
        $.each(prodToCart, function(i, res){
          var found = false;
          for(var j = 0; j < data.items.length; j++) {
            if(data.items[j].id == res.id) {
            	data.items[j].quantity += 1;
            	found = true;
              	break;
            }
          }
          if(!found) {
            data.items.push({
              id: res.id,
              quantity: res.quantity,
              properties: {
                _hmcollection: collID,
                _hmname: activeBundle.name,
                _hmdiscount: activeBundle.discount,
                _hmitems: activeBundle.maxItems,
              }
            });
          }
          
        });
      
      
      	fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
            })
            .then(response => {
              window.location.href = "/cart";
       });
    });
    
    $(document).on('click', 'div.remove',function(e){
      	e.preventDefault();
    	var idx = $(this).data("idx");
      	prodToCart.splice(idx, 1);
      	setBundle({}, true);
    });
    
    $(".arrow").click(function(e){
    	e.preventDefault();
      	$(".bundle-previews").toggle();
        $(".arrow").toggle();
    
    });
    
    
    fetch(`${apiurl}/api/bundles?collection=${collID}`).then(function(resp){
          return resp.json();
        }).then(function(data){
          if(data.sucess) {
              bundleConfig = data.data;
              initBundle();
          }
      }); 
    

    

  
  }
  
})();
